import { SpeechConfigProvider } from '@provider/speech-synthesis';
import { ExportServiceFontFixer } from '@utils/component-framework';
import '@i-ark/models';
import 'react';
import '@tanstack/react-query';
import { selectPrintOrientation } from '../../state/selectors/print.get-orientation.js';
import { iArkStore } from '../../state/store.js';
import { SheetWrapper } from '../organism.sheet/_sheet.js';
import { printContainer, item } from './_print.root.style.js';
import { PrintFooter } from './print.footer.js';
import { PrintHeader } from './print.header.js';
import { jsxs, jsx } from 'react/jsx-runtime';

const DISABLED_POLLY_CONFIG = {
  enabled: false,
  gender: undefined,
  karaoke: false,
  languages: undefined,
  latexPrinter: undefined,
  speed: 3
};
function PrintLayout(props) {
  const enabled = iArkStore.useSelector(state => state.showPrintLayout);
  const printOrientation = iArkStore.useSelector(selectPrintOrientation);
  if (!enabled) {
    return null;
  }
  return /*#__PURE__*/jsxs("div", {
    className: printContainer,
    "data-orientation": printOrientation,
    "aria-hidden": true,
    "data-disable-polly": true,
    "data-print-target": true,
    children: [/*#__PURE__*/jsx(ExportServiceFontFixer, {}), props.component.pages.map(page => /*#__PURE__*/jsxs("div", {
      className: item,
      children: [/*#__PURE__*/jsx(PrintHeader, {}), /*#__PURE__*/jsx(SpeechConfigProvider, {
        config: DISABLED_POLLY_CONFIG,
        children: /*#__PURE__*/jsx(SheetWrapper, {
          isPrinting: true,
          defaultInputColor: props.component.style.colors.inputTextColor ?? "#000",
          defaultTextColor: props.component.style.colors.textColor ?? "#000",
          page: page,
          context: "standalone"
        })
      }), /*#__PURE__*/jsx(PrintFooter, {})]
    }, page.id))]
  });
}

export { PrintLayout };
//# sourceMappingURL=_print.root.js.map
